import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Star } from "lucide-react";
import { Button } from "@/components/ui/button";

export function Reviews() {
  const [reviews, setReviews] = useState([]);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    api.get("/reviews").then(({ data }) => setReviews(data)).catch(() => {});
  }, []);

  if (reviews.length === 0) return null;
  const shown = showAll ? reviews : reviews.slice(0, 5);

  return (
    <section data-testid="reviews-section" className="mx-auto max-w-7xl px-6 py-20">
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-500">// Client reviews</p>
      <h2 className="mt-2 font-display text-3xl font-bold tracking-tight sm:text-4xl">What clients say.</h2>
      <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {shown.map((r) => (
          <div key={r.id} data-testid={`review-${r.id}`}
            className="border border-white/10 bg-[#0A0A0B] p-6 transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-white/25">
            <div className="flex gap-0.5">
              {[1, 2, 3, 4, 5].map((s) => (
                <Star key={s} className={`h-4 w-4 ${s <= r.rating ? "fill-primary text-primary" : "text-zinc-700"}`} />
              ))}
            </div>
            <p className="mt-4 text-sm leading-relaxed text-zinc-300">"{r.text}"</p>
            <div className="mt-4 font-mono text-xs text-zinc-500">
              — {r.name}{r.email ? ` · ${r.email}` : ""}
            </div>
          </div>
        ))}
      </div>
      {reviews.length > 5 && !showAll && (
        <div className="mt-8 text-center">
          <Button data-testid="reviews-view-more" variant="ghost" onClick={() => setShowAll(true)}
            className="rounded-full border border-white/15 text-zinc-200 hover:bg-white/5 hover:text-white">
            View more reviews
          </Button>
        </div>
      )}
    </section>
  );
}
